@use '@/styles/tokens' as *;

.banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  // Pale yellow "queued" wash from the Figma (2640-811881); no token equivalent.
  background: #fbfbcb;
  border-radius: 16px;
  padding: var(--space-3) var(--space-5);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  font-weight: 600;
  color: $color-neutral-950;
}

.subtitle {
  color: $color-neutral-700;
  font-size: 14px;
}

.cancel {
  flex-shrink: 0;
}
